var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPfeilRechtsBolder = function SvgPfeilRechtsBolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    fill: "currentColor",
    "aria-label": "Nach rechts",
    viewBox: "0 0 24 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.58 8.32-7.9-7.9c-.56-.56-1.48-.56-2.04 0s-.56 1.48 0 2.04l5.44 5.44H1.45C.65 7.89 0 8.54 0 9.34s.65 1.45 1.45 1.45h17.62l-5.44 5.44c-.56.56-.56 1.48 0 2.04.28.28.65.42 1.02.42s.74-.14 1.02-.42l7.9-7.9c.56-.56.56-1.48 0-2.04z"
  })));
};
export default SvgPfeilRechtsBolder;